'use client';
import React from 'react';
import { Layout } from '@benzinga/core-ui';
import { QuizSidebar } from './QuizSidebar';

const RiverdropQuizBlock = React.lazy(() =>
  import('@benzinga/blocks').then(module => {
    return { default: module.RiverdropQuizBlock };
  }),
);

interface Props {
  quizId: string;
  latestQuizId?: string;
  trendingArticleId?: number;
}

export const QuizLayout: React.FC<Props> = ({ quizId, latestQuizId, trendingArticleId }) => {
  return (
    <>
      <Layout
        layoutMain={
          <>
            <RiverdropQuizBlock form_factor="desktop" partner_id="ChihKCDRc5E7vh2O66g3" quiz_id={quizId ?? ''} />
            <div className="flex justify-center mt-4 gap-2">
              {quizId !== latestQuizId && (
                <a
                  href={`/quiz/${latestQuizId}`}
                  className="px-4 py-2 rounded border-none text-sm font-semibold cursor-pointer transition-all bg-blue-500 text-white hover:bg-blue-600"
                >
                  Play Latest Quiz
                </a>
              )}
              <a
                href={`/quiz/leaderboard`}
                className="px-4 py-2 rounded border-none text-sm font-semibold cursor-pointer transition-all bg-blue-100 text-slate-500 hover:bg-slate-100"
              >
                View Leaderboard
              </a>
            </div>
            <div className="mt-4 italic text-sm">
              By participating, you agree to the rules found{' '}
              <a href="/quiz/rules" className="hover:underline">
                here
              </a>
            </div>
          </>
        }
        layoutSidebar={<QuizSidebar trendingArticleId={trendingArticleId} />}
        sidebarSettings={{ sticky: false }}
        title="Benzinga Bell Ringer"
      />
    </>
  );
};
